import { useQuery } from '@tanstack/react-query'

import { getCorrespondentDomain, queries } from '~/features/partners/utils'

type TOptions = {
  shouldFetch?: boolean
}

type TProps = {
  shouldLoadByDomain: boolean
  options?: TOptions
}

const useGetPartnerConfigByDomain = ({
  shouldLoadByDomain,
  options,
}: TProps) => {
  const { shouldFetch = true } = options || {}
  const domain = getCorrespondentDomain()

  return useQuery({
    ...queries.partnerByDomain(shouldLoadByDomain),
    enabled: shouldFetch && shouldLoadByDomain && !!domain,
  })
}

export default useGetPartnerConfigByDomain
